import * as NativeAdapter from './NativeAdapter'

export default NativeAdapter
